import React, { useContext } from 'react';

const PostContext = React.createContext();

const PostProvider = ({ defaultValues, ...restProps }) => {
    return <PostContext.Provider value={defaultValues} {...restProps} />;
};

const usePost = () => {
    const context = useContext(PostContext);
    if (!context) {
        throw new Error('usePost must be used within a PostProvider');
    }
    return context;
};

export { PostProvider, usePost };
